import React, { useCallback, useState } from "react";
import Button from "../../components/Button";
import { Image, View } from "react-native";
import VStack from "../../ui_atoms/VStack";
import type { Meta, StoryObj } from "@storybook/react";
import { UnifiedImagePickerAsset, useCropZoomImage } from "../../hooks/crop-zoom-image";
import { BodySmallText } from "../../components/FormattedText";
import * as ImagePicker from "expo-image-picker";

const TEST_ASSET_WEBP = {
    uri: "https://storage.googleapis.com/lift-public-assets/dev-storybook/naruto-familly.webp",
    name: "naruto-familly.webp",
    mimeType: "image/webp",
    fileName: "naruto-familly.webp",
};

const TEST_ASSET_PNG = {
    uri: "https://storage.googleapis.com/lift-public-assets/dev-storybook/naruto-familly.png",
    name: "naruto-familly.png",
    mimeType: "image/png",
    fileName: "naruto-familly.png",
};

const TEST_ASSET_JPEG = {
    uri: "https://storage.googleapis.com/lift-public-assets/dev-storybook/naruto-familly.jpg",
    name: "naruto-familly.jpg",
    mimeType: "image/jpg",
    fileName: "naruto-familly.jpg",
};

const TEST_ASSET_HEIGHT = {
    uri: "https://storage.googleapis.com/lift-public-assets/dev-storybook/mire-height.png",
    name: "mire-height.png",
    mimeType: "image/png",
    fileName: "mire-height.png",
};

const ComponentStory = () => {
    const [newAssetUri, setNewAssetUri] = useState<UnifiedImagePickerAsset | null>(null);
    const performCropZoom = useCropZoomImage();

    const onPressPng = useCallback(async () => {
        setNewAssetUri(null);
        const newAsset = await performCropZoom(TEST_ASSET_PNG);
        setNewAssetUri(newAsset);
    }, [performCropZoom]);

    const onPressWebp = useCallback(async () => {
        setNewAssetUri(null);
        const newAsset = await performCropZoom(TEST_ASSET_WEBP);
        setNewAssetUri(newAsset);
    }, [performCropZoom]);

    const onPressJpeg = useCallback(async () => {
        setNewAssetUri(null);
        const newAsset = await performCropZoom(TEST_ASSET_JPEG);
        setNewAssetUri(newAsset);
    }, [performCropZoom]);

    const onPressHeight = useCallback(async () => {
        setNewAssetUri(null);
        const newAsset = await performCropZoom(TEST_ASSET_HEIGHT);
        setNewAssetUri(newAsset);
    }, [performCropZoom]);

    const onPressPhoto = useCallback(async () => {
        setNewAssetUri(null);
        const pickerResult = await ImagePicker.launchCameraAsync({
            mediaTypes: "images" as ImagePicker.MediaType,
            quality: 0.6,
        });
        if (!pickerResult.canceled) {
            const newAsset = await performCropZoom(pickerResult.assets[0]);
            setNewAssetUri(newAsset);
        }
    }, [performCropZoom]);

    const onPressLibrary = useCallback(async () => {
        setNewAssetUri(null);
        const pickerResult = await ImagePicker.launchImageLibraryAsync({
            mediaTypes: "images" as ImagePicker.MediaType,
        });
        if (!pickerResult.canceled) {
            const newAsset = await performCropZoom(pickerResult.assets[0]);
            setNewAssetUri(newAsset);
        }
    }, [performCropZoom]);
    return (
        <VStack gap={0.5} alignment="stretch" style={{ width: "100%" }}>
            <Button label="TEST crop zoom (PNG)" onPress={onPressPng} />
            <Button label="TEST crop zoom (JPEG)" onPress={onPressJpeg} />
            <Button label="TEST crop zoom (WEBP)" onPress={onPressWebp} />
            <Button label="TEST crop zoom (Heigh)" onPress={onPressHeight} />
            <View
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flex: 1,
                    justifyContent: "space-between",
                }}
            >
                <Button label="TEST Photo" onPress={onPressPhoto} />
                <Button label="TEST Library" onPress={onPressLibrary} />
            </View>
            {newAssetUri ? (
                <VStack alignment="center">
                    <Image source={{ uri: newAssetUri.uri }} style={{ width: 300, height: 300 }} />
                    <BodySmallText>{newAssetUri.name}</BodySmallText>
                    <BodySmallText>{newAssetUri.mimeType}</BodySmallText>
                    <BodySmallText>{newAssetUri.fileName}</BodySmallText>
                </VStack>
            ) : null}
        </VStack>
    );
};

const meta = {
    title: "Components/Image Crop Zoom",
    component: ComponentStory,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof ComponentStory>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};
